import { render, staticRenderFns } from "./disciplinas.vue?vue&type=template&id=158f905e"
import script from "./disciplinas.vue?vue&type=script&lang=js"
export * from "./disciplinas.vue?vue&type=script&lang=js"
import style0 from "./disciplinas.vue?vue&type=style&index=0&id=158f905e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports